import { render, staticRenderFns } from "./hospitalModal.vue?vue&type=template&id=9a850234&scoped=true&"
import script from "./hospitalModal.vue?vue&type=script&lang=js&"
export * from "./hospitalModal.vue?vue&type=script&lang=js&"
import style0 from "./hospitalModal.vue?vue&type=style&index=0&id=9a850234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a850234",
  null
  
)

export default component.exports